"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const utilities_1 = require("../../utilities");
const Button_1 = tslib_1.__importDefault(require("../../Button"));
const styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  > * {
    width: 100%;
    margin: 4px;
  }
`;
class AspectRatioPicker extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.renderOne = (aspectRatio, idx) => {
            const { value, onChange } = this.props;
            return (React.createElement(Button_1.default, { key: idx, primary: true, block: true, size: "xs", basic: value !== aspectRatio, onClick: () => onChange(aspectRatio) }, aspectRatio === null ? (0, utilities_1.__)('Voľný') : aspectRatio));
        };
    }
    render() {
        const { options } = this.props;
        return React.createElement(Wrapper, null, options.map(this.renderOne));
    }
}
exports.default = AspectRatioPicker;
